"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "COLOR", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.COLOR;
  }
});
Object.defineProperty(exports, "KIND", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.KIND;
  }
});
Object.defineProperty(exports, "SIZE", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.SIZE;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon2["default"];
  }
});
var _SvgIcon = require("./SvgIcon.types");
var _SvgIcon2 = _interopRequireDefault(require("./SvgIcon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}